import React from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {formatNumber} from "../cabinetShell/config";

import {setMatrixSellModalStatus, setMatrixSellWarningModalStatus} from "../../store/cabinet/action";



const CabinetMatrixSellWarningModal = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const userData = useSelector(store => store.cabinet.userData);

    const matrixSellWarningModalStatus = useSelector(store => store.cabinet.matrixSellWarningModalStatus);

    const closeModal = () =>{
        dispatch(setMatrixSellWarningModalStatus(false));
    }

    const mainBtnHandler = () =>{
        closeModal();
        localStorage.setItem('ftf-swms', 'accept');
        dispatch(setMatrixSellModalStatus(true));
    }

    return (
        <DsModal
            open={matrixSellWarningModalStatus}
            onClose={closeModal}
            size="sm"
            title={t('Продажа токенов')}
        >
            <div className={Form.info}>
                <div className={`${Form.infoRow} ${Form.infoRowTotal}`}>
                    <span>{t('Ваш баланс токенов')}</span>
                    <span>{formatNumber(userData?.user?.tokens)} FTF</span>
                </div>
            </div>
            <div className={Form.note}>
                {t('Нажимая кнопку «Продать токены», вы понимаете, что больше не сможете вернуть токены — они будут проданы автоматически.')}
            </div>
            <div className={Form.actions}>
                <button type="button" className={Form.btnNeutral} onClick={closeModal}>{t('Отмена')}</button>
                <button type="button" className={Form.btnAccent} onClick={mainBtnHandler}>{t('Да, я понимаю!')}</button>
            </div>
        </DsModal>
    );
};

export default CabinetMatrixSellWarningModal;
